module.exports = __webpack_public_path__ + "static/media/5D.3ba37a23.jpg";